module.exports = __webpack_public_path__ + "static/img/about2.159caa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about2.png
// module id = IpDh
// module chunks = 11